import styled from 'vue-styled-components';

export const BusBackContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
`

